import React, {useContext, createContext} from 'react'
import {Modal, Button} from 'react-bootstrap'

import './EqxModal.css'

class eqxModalStateManager {
    shown: boolean
    setShown: (show: boolean) => void
    constructor(props: {shown: boolean; setShown: (show: boolean) => void}) {
        this.shown = props.shown ?? false
        this.setShown = props.setShown
    }
    show() {
        this.setShown(true)
    }
    hide() {
        this.setShown(false)
    }
}
const useModalState = (state?: eqxModalStateManager) => {
    const [shown, setShown] = React.useState<boolean>(false)
    return state ?? new eqxModalStateManager({shown: shown ?? false, setShown: setShown ?? (() => {})})
}
const useDerivedModalState = (props: {shown: boolean; setShown?: () => void; onHide?: () => void}) => {
    const setShown =
        props.setShown ??
        (props.onHide
            ? (val: boolean) => {
                  if (!val && props.onHide) props.onHide()
                  else console.error('Cannot show modal without setShown function')
              }
            : () => {})
    return new eqxModalStateManager({shown: props.shown, setShown: setShown})
}
const useModalContext = (): eqxModalStateManager => {
    const context = useContext(EqxModalContext)
    if (!context) throw new Error('useModalContext must be used within an EqxModalContextProvider')
    return context
}
const useModalContextOptional = (): eqxModalStateManager | null => {
    const context = useContext(EqxModalContext)
    return context
}
interface EqxModalContextProviderProps {
    value: eqxModalStateManager
    children: React.ReactNode
}
const EqxModalContext = createContext<eqxModalStateManager | null>(null)
const EqxModalContextProvider = (props: EqxModalContextProviderProps) => {
    const existingContext = useModalContextOptional()
    if (existingContext) {
        return <>{props.children}</>
    }
    return <EqxModalContext.Provider value={props.value}>{props.children}</EqxModalContext.Provider>
}

interface EqxModalProps {
    children: React.ReactNode
    header?: React.ReactNode
    footer?: React.ReactNode
    title: React.ReactNode
    state?: eqxModalStateManager
    shown?: boolean
    noPadding?: boolean
    setShown?: (show: boolean) => void
    onHide?: () => void
}
const EqxModal = (props: EqxModalProps) => {
    let state =
        props.state ?? new eqxModalStateManager({shown: props.shown ?? false, setShown: props.setShown ?? (() => {})})
    const onHide = () => {
        state.hide()
        if (props.onHide) props.onHide()
    }

    return (
        <EqxModalContextProvider value={state}>
            <Modal
                show={state.shown}
                onHide={onHide}
                size="lg"
                fullscreen="lg-down"
                className={props.noPadding ? 'no-padding' : ''}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{props.title}</Modal.Title>
                    {props.header}
                </Modal.Header>

                <Modal.Body>{props.children}</Modal.Body>

                <Modal.Footer>
                    {props.footer ?? (
                        <Button variant="outline-secondary" onClick={onHide}>
                            OK
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </EqxModalContextProvider>
    )
}
export {EqxModal as default, useModalState, useDerivedModalState, useModalContext, type eqxModalStateManager}
